import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    exportErrorMsg: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** A generic error message shown when exporting a sequence fails */
            exportErrorMsg: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useExportAndUploadSequence.exportErrorMsg?c=3bxl8tnqfkz83", defaultMessage: "Error exporting sequence" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
